import { apiClient } from "../../../lib";
import { BudgetCastPerformance } from "../types";

export const budgetCastPerformance = {

    fetch: async (): Promise<BudgetCastPerformance> => {
        const response = await apiClient.get(`/projects/budget-cost-performance`);
        return response.data.data;
    },

}